<template>
  <b-notification v-show="visibleNews.length" type="is-success" class="mb-4 is-light" animation="fade" :auto-close="true" :duration="10000">
    <p class="has-text-left">
      WHAT'S NEW?
    </p>
    <div class="content">
      <ul class="has-text-left">
        <li v-for="newsItem in visibleNews" :key="newsItem.id">
          <i>{{ newsItem.date | asDate }}:</i>&nbsp;
          <a v-if="newsItem.url" :href="newsItem.url"> {{ newsItem.text }} </a>
          <span v-else>{{ newsItem.text }}</span>
        </li>
      </ul>
    </div>
  </b-notification>
</template>

<script>
import { firestore } from "@/services/firebase";

export default {
  props: ["open"],

  data() {
    return {
      news: [],
    };
  },

  computed: {
    visibleNews() {
      return this.news
        .filter((n) => !n.isHidden)
        .sort((a, b) => b.date - a.date);
    },
  },

  firestore: {
    news: firestore.collection("news"),
  },

  filters: {
    studentPage(page) {
      return `//www.chesssquad.com/pages/chess-student/${page}`;
    },

    commonStrategyPage(page) {
      return `//www.chesssquad.com/pages/common/strategy-games/${page}`;
    },
  },
};
</script>

<style scoped></style>
